import { Box, Button, customStyled, Flex } from '@mafc/trolly';
import COLORS from 'theme/colors';
import { RoundCornerButton } from 'common/styled/Button.style';
import { StyledDrawerTitle } from 'common/styled/Drawer.style';

export const AppliedPromo = customStyled(Flex)(({ theme: { radii, fontSizes, space } }) => ({
  borderRadius: radii[4],
  backgroundColor: COLORS.BLUE_25,
  fontSize: fontSizes[1],
  justifyContent: 'space-between',
  marginBottom: space[3],
  padding: space[2],
  lineHeight: `${space[3]}px`,
}));

export const AvailablePromotionsDrawerBody = customStyled(Flex)(({ theme: { fonts } }) => ({
  flexDirection: 'column',
  height: 'calc(100% - 72px)',
  fontFamily: fonts.montserrat,
  marginTop: '-24px',
}));

export const DrawerTitle = customStyled(StyledDrawerTitle)(() => ({
  alignItems: 'center',
}));

export const EnterCodeButton = customStyled(Button)(
  ({ theme: { fontSizes, fontWeights, radii } }) => ({
    height: 'auto',
    fontSize: fontSizes[2],
    fontWeight: fontWeights[7],
    borderRadius: radii[4],
    padding: '8px 16px',
  })
);

export const SelectOneVoucher = customStyled(Box)(
  ({ theme: { fontSizes, fontWeights, space } }) => ({
    margin: `${space[1]}px 0 ${space[3]}px 0`,
    height: '24px',
    fontSize: fontSizes[2],
    fontWeight: fontWeights[2],
  })
);

export const RemovePromoButton = customStyled(RoundCornerButton)(() => ({
  padding: 0,
  width: '84px',
  height: '38px',
  whiteSpace: 'nowrap',
}));

export const RefreshButton = customStyled(RoundCornerButton)(({ theme: { fonts } }) => ({
  height: '36px',
}));
